import styled from '@emotion/styled';
import {Dialog} from '@bosch/react-frok';

export const DialogWrapper = styled(Dialog)`
    .m-dialog__actions {
        display: grid;
        grid-template-columns: max-content auto max-content;
        justify-content: normal;
        margin-top: -10px;
    }
`;

export const TextWrapper = styled.div`
    font-size: small;
    white-space: pre-line;
    & > p {
        margin-top: 0;
        font-size: 1rem;
    }
`;

export const BrowseLabel = styled.div`
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
`;

export const Label = styled.label`
    display: inline-block;
    width: 100%;
`;
